import React from 'react'

import {
  AlignItems,
  Body2,
  Box,
  Display,
  Heading1,
  JustifyContent,
  TextAlign,
} from '@gousto-internal/citrus-react'

import { LandingPageButton } from '../../../../components/LandingPageButton'
import type { HowGoustoFoodBoxesWorkTypes } from '../../../../types'
import {
  HowGoustoFoodBoxesWorkSections,
  TargetUri,
  TrackingActions,
} from '../../../../types/tracking'
import { HERO_SECTION_COPY } from './config'

export function HeroSection({ startOnboarding }: HowGoustoFoodBoxesWorkTypes) {
  return (
    <Box
      display={Display.Flex}
      alignItems={AlignItems.Center}
      justifyContent={JustifyContent.Center}
      paddingH={[8, 20]}
      paddingV={16}
    >
      <Box maxWidth="512px">
        <Box paddingBottom={3}>
          <Heading1 textAlign={TextAlign.Center}>{HERO_SECTION_COPY.mainHeadingLine1}</Heading1>
        </Box>

        <Box paddingBottom={[4, 5]}>
          <Box paddingBottom={3}>
            <Body2 size={4} textAlign={TextAlign.Center}>
              {HERO_SECTION_COPY.descriptionParagraph1}
            </Body2>
          </Box>
        </Box>

        <Box display={Display.Flex} justifyContent={JustifyContent.Center}>
          <LandingPageButton
            action={TrackingActions.CLICK_RECIPE_NAVIGATION}
            sectionName={HowGoustoFoodBoxesWorkSections.HERO_SECTION}
            target={TargetUri.MENU}
            startOnboarding={startOnboarding}
          >
            {HERO_SECTION_COPY.ctaButtonText}
          </LandingPageButton>
        </Box>
      </Box>
    </Box>
  )
}
